import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import VertStepper from './../Steppers/VertStepper';

export default function AddFormInfoComponent(props) {

    const classes = useStyles();
    const [steps, setSteps] = useState()
    const [updateVertSteps, setUpdateVertSteps] = useState(false)

    useEffect(() => {

        let stepArray = [
            { "id": 1, "name": "Broker", "isComplete": false, "isInProgress": true, "hasPrevious": false, "hasNext": true, "formComponentName": "broker" },
            { "id": 2, "name": "Type of contract", "isComplete": false, "isInProgress": true, "hasPrevious": true, "hasNext": true, "formComponentName": "typeOfContract" },
            { "id": 3, "name": "Year of harvest", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "yearOfHarvest" },
            { "id": 4, "name": "Date of contract", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "dateOfContract" },
            { "id": 5, "name": "Valid untill (optional)", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "validUntill" },
            { "id": 6, "name": "Type of supplier", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "supplierType" },
            { "id": 7, "name": "Supplier", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "supplier" },
            { "id": 8, "name": "Buying units", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "buyingUnits" },
            { "id": 9, "name": "Transport types", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "transportTypes" },
            { "id": 10, "name": "Transport price per 100kg", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "transportPrice100Kg" },
            { "id": 11, "name": "Certificate Info", "isComplete": false, "isInProgress": false, "hasPrevious": true, "hasNext": true, "formComponentName": "certInfo" }
        ]

        let chosenValues = GetChosenValues();
        stepArray.map((x) => {
            x.chosenValue = chosenValues[x.id];
            if (x.id < props.addPage.vertStep) {
                x.isComplete = true;
                x.isInProgress = false;
            } else if (x.id === props.addPage.vertStep) {
                x.isInProgress = true;
                x.isComplete = false;
            } else {
                x.isComplete = false;
                x.isInProgress = false;
            }
        });

        if (JSON.stringify(steps) !== JSON.stringify(stepArray)) {
            setSteps(stepArray)
        }

    }, [updateVertSteps, props.addPage.vertStep])

    const GetChosenValues = () => {
        return {
            1: props.addPage.brokerName,
            2: props.addPage.purchaseOrderTypeName,
            3: props.addPage.harvestYear,
            4: props.addPage.contractDate,
            5: props.addPage.validUntillDate,
            6: props.addPage.vendorTypeName,
            7: props.addPage.vendorName,
            8: props.addPage.unitOfMeasurementName,
            9: props.addPage.transportTypeName,
            10: props.addPage.transportPrice100Kg,
            11:{number:props.addPage.certificateInfo && props.addPage.certificateInfo.number,validUntil:props.addPage.certificateInfo && props.addPage.certificateInfo.validUntil}
        };
    };

    const SetPrevious = () => {
        var newstep = props.addPage.vertStep - 1;
        props.actions.setVertstep(newstep);
    }

    const SetNext = () => {
        if (props.addPage.vertStep === steps.length) {
            props.SetNext();
        } else {
            var newstep = props.addPage.vertStep + 1;
            props.actions.setVertstep(newstep);
        }

        setUpdateVertSteps(!updateVertSteps)
    }

    const resetFormAction = () => {
        props.actions.ResetAddForm();   
        // props.actions.ResetAddPageTitle();
    }

    return (
        <div className={classes.formContainer}>
            <div className={classes.buttonContainer}>
                <button className={classes.button} onClick={() => resetFormAction()}>{"RESET CONTRACT"}</button>
            </div>
            <VertStepper  actions={props.actions} {...props} localstore={props.localstore} steps={steps} SetPrevious={SetPrevious} SetNext={SetNext}></VertStepper>
            <div className={classes.spacer}></div>
        </div>
    )

}

const useStyles = makeStyles({
    spacer: {
        height: 500
    },
    buttonContainer: {
        margin: 20,
        marginTop: "40px",
        marginBottom: "30px",
        textAlign: "center"
    },
    button: {
        fontFamily: "Roboto",
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "#1976d2",
        color: "white",
        height: "30px",
        width: "150px",
        fontSize: "14px"

    },
    formContainer: {
        width: "1000px",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box"
    }
});